import SvgStarFilledIcon from "@/components/svg/StarFilledIcon";
import SvgStarOutlineIcon from "@/components/svg/StarOutline";
import { chakra, HStack } from "@chakra-ui/react";

export interface StarRatingProps {
  rating: number;
  maxRating?: number;
}

export default chakra(StarRating);
function StarRating({ rating, maxRating = 5 }: StarRatingProps) {
  return (
    <HStack spacing={0} h={10}>
      {Array.from({ length: maxRating }).map((_, index) =>
        index < rating ? (
          <SvgStarFilledIcon key={index} />
        ) : (
          <SvgStarOutlineIcon key={index} />
        ),
      )}
    </HStack>
  );
}
